<template>
  <EditorTabFrame
    :loading="loading"
    :loaded="loaded"
    :load-error="loadError"
    :saving="saving"
    :dirty="isDirty"
    :conflict-message="conflictMessage"
    @save="save"
    @discard="discard"
    @reload="load"
  >
    <div v-if="form">
      <EditorSection
        title="Compartilhamento"
        description="Como o link da campanha aparece no WhatsApp e nas redes sociais. A mesma imagem é usada como ícone da aba do navegador."
      >
        <div class="ed-identity">
          <EditorImageField label="Imagem de compartilhamento" :current-path="faviconPath" :max-kb="500" v-model="newFavicon" />
          <div>
            <InputText
              v-model="form.metaTitle"
              type="text"
              place-holder="Ex.: Sou Osesp | Seja parte da nossa história"
              textLabel="Título"
              labelCharLimit="60"
              :required="false"
            />
            <InputTextArea
              v-model="form.metaDescription"
              labelAreaCharLimit="160"
              rows="3"
              place-holder="Uma frase que convide a pessoa a doar"
              textLabel="Descrição"
              :required="false"
            />
            <span class="ed-label mt-3">Prévia</span>
            <PreviewShare
              :title="form.metaTitle"
              :description="form.metaDescription"
              :image-path="previewImage"
              :subdomain="subdomain"
            />
          </div>
        </div>
      </EditorSection>

      <EditorSection title="Medição e anúncios" description="IDs das ferramentas que acompanham as visitas e as conversões da campanha.">
        <div class="ed-grid ed-grid--3">
          <div>
            <InputText v-model="form.googleAnalyticsId" type="text" place-holder="Ex.: G-XXXXXXX" textLabel="Google Analytics" labelCharLimit="20" :required="false" />
          </div>
          <div>
            <InputText v-model="form.googleTagManager" type="text" place-holder="Ex.: GTM-NXNZT4C" textLabel="Google Tag Manager" labelCharLimit="20" :required="false" />
          </div>
          <div>
            <InputText v-model="form.facebookPixelId" type="text" place-holder="Ex.: 0123456789" textLabel="Pixel do Facebook" labelCharLimit="20" :required="false" />
          </div>
        </div>
      </EditorSection>
    </div>
  </EditorTabFrame>
</template>

<script>
import editorTab from "../editorTab.mixin";
import EditorTabFrame from "../EditorTabFrame.vue";
import EditorSection from "../EditorSection.vue";
import EditorImageField from "../EditorImageField.vue";
import InputText from "@/components/input/InputText.vue";
import InputTextArea from "@/components/input/InputTextArea.vue";
import PreviewShare from "@/components/PreviewShare.vue";
import CampaignEditorService from "@/scripts/services/campaignEditor.service";

const service = new CampaignEditorService();

export default {
  name: "SharingTab",
  mixins: [editorTab],
  components: { EditorSection, EditorTabFrame, EditorImageField, InputText, InputTextArea, PreviewShare },
  data() {
    return {
      subdomain: null,
      faviconPath: null,
      newFavicon: null,
    };
  },
  computed: {
    previewImage() {
      return (this.newFavicon && this.newFavicon.dataUri) || this.faviconPath || "";
    },
  },
  methods: {
    fetchSection() {
      return service.getSharing(this.campaignId);
    },
    saveSection(body) {
      return service.saveSharing(body);
    },
    toForm(dto) {
      return {
        metaTitle: dto.metaTitle || "",
        metaDescription: dto.metaDescription || "",
        googleAnalyticsId: dto.googleAnalyticsId || "",
        googleTagManager: dto.googleTagManager || "",
        facebookPixelId: dto.facebookPixelId || "",
      };
    },
    afterLoad(dto) {
      this.subdomain = dto.subdomain;
      this.faviconPath = dto.favicon ? dto.favicon.path : null;
      this.newFavicon = null;
    },
    afterSave() {
      if (this.newFavicon) this.faviconPath = this.newFavicon.dataUri;
      this.newFavicon = null;
    },
    hasPendingFiles() {
      return !!this.newFavicon;
    },
    buildPayload() {
      return Object.assign({}, this.form, { newFavicon: this.newFavicon });
    },
  },
};
</script>
